import { render, staticRenderFns } from "./StageCaution.vue?vue&type=template&id=391ba6ea&"
import script from "./StageCaution.vue?vue&type=script&lang=js&"
export * from "./StageCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports